<kodit-card-container>
  <div card-title class="p-mb-3">
    Uplate po računu ({{ racunInfoDto.procenatIznos }}%)
  </div>

  <div card-subtitle class="p-d-flex p-ai-center" style="width: 100%;">
    <p-progressBar
      [showValue]="false"
      [value]="racunInfoDto.procenatIznos"
      [style]="{ width: '100%' }"
    ></p-progressBar>
  </div>

  <div card-right-side class="p-d-flex p-ai-center">
    <div
      [ngClass]="
        'p-text-center info-badge status status-uplate-racuna-' +
        racunInfoDto.statusUplateDto.statusBadgeStr
      "
      style="white-space: nowrap; min-width: 120px;"
    >
      {{ racunInfoDto.statusUplateDto.statusStr.toUpperCase() }}
    </div>
  </div>

  <div class="p-d-flex p-flex-column gap-12" card-body>

    <div *ngIf="showButton || showPovecanjeSmanjenjeButton" class="p-grid p-nogutter p-mb-3" style="gap: 8px;">
      <div *ngIf="showButton" class="p-col">
        <button
          icon="far fa-credit-card"
          pButton
          type="button"
          label="Evidentiraj uplatu"
          class="p-button p-button-outlined w-100"
          (click)="onEdit()"
        ></button>
      </div>
      <div *ngIf="showPovecanjeSmanjenjeButton" class="p-col">
        <button
          icon="far fa-arrow-up"
          pButton
          type="button"
          label="Evidentiraj povećanje"
          class="p-button p-button-outlined w-100"
          (click)="onEvidentirajPovecanje()"
        ></button>
      </div>
      <div *ngIf="showPovecanjeSmanjenjeButton" class="p-col">
        <button
          icon="far fa-arrow-down"
          pButton
          type="button"
          label="Evidentiraj smanjenje"
          class="p-button p-button-outlined w-100"
          (click)="onEvidentirajSmanjenje()"
        ></button>
      </div>
    </div>

    <div class="p-d-flex p-jc-between">
      <div>
        <div class="p-d-flex p-mb-2">
          <div class="p-pr-2 p-label">Za uplatu:</div>
          <div class="p-text">{{ racunInfoDto.iznosStr }}</div>
        </div>
        <div class="p-d-flex p-mb-2">
          <div class="p-pr-2 p-label">Uplaćeno:</div>
          <div class="p-text">{{ racunInfoDto.uplacenoStr }}</div>
        </div>
        <div class="p-d-flex p-mb-2">
          <div class="p-pr-2 p-label">Preostalo:</div>
          <div class="p-text">{{ racunInfoDto.preostaloStr }}</div>
        </div>
      </div>
      
      <div>
        <div class="p-d-flex p-jc-end p-mb-2">
          <div class="p-pr-2 p-label">Rok za plaćanje:</div>
          <div class="p-text">{{ racunInfoDto.datumValuteStr }}</div>
        </div>
        <div
          class="p-d-flex p-jc-end p-mb-2"
          *ngIf="racunInfoDto.datumValuteTekstUpozorenja && racunInfoDto.statusUplateDto.status != statusPlacen"
        >
          <div class="k-label-warning">
            {{ racunInfoDto.datumValuteTekstUpozorenja }}
          </div>
        </div>
      </div>
    </div>

    <div>
      <kodit-uplate-po-racunu-table
        [uplateTable]="racunInfoDto.uplateRacunaTable"
      ></kodit-uplate-po-racunu-table>
    </div>
  </div>
</kodit-card-container>